export default {
  momentLocale: 'fr',
  Timeline: {
    expand: 'Développer',
    fold: 'Réduire',
  },
  Balloon: {
    close: 'Fermer',
    confirm: 'Confirmer',
    cancel: 'Annuler',
  },
  Card: {
    expand: 'Développer',
    fold: 'Réduire',
  },
  Calendar: {
    today: "Aujourd'hui",
    now: 'Ce moment',
    ok: 'Confirmer',
    clear: 'Effacer',
    month: 'Mois',
    year: 'année',
    prevYear: 'Année précédente',
    nextYear: "l'année prochaine",
    prevMonth: 'Le Mois Dernier',
    nextMonth: 'Mois prochain',
    prevDecade: 'Douze Années Précédentes',
    nextDecade: 'Douze ans plus tard',
    yearSelectAriaLabel: "Sélectionnez l'année",
    monthSelectAriaLabel: 'Sélectionnez le mois',
    format: {
      months: '1 mois_2 mois_3 mois_4 mois_5 mois_6 mois_7 mois_8 mois_9 mois_10 mois_11 mois_12 mois'.split(
        '_',
      ),
      shortMonths: '1 mois_2 mois_3 mois_4 mois_5 mois_6 mois_7 mois_8 mois_9 mois_10 mois_11 mois_12 mois'.split(
        '_',
      ),
      weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
      shortWeekdays: 'Dim_Lun_Mar_Mer_Jeu_Ven_Sam'.split('_'),
      veryShortWeekdays: 'Dim_Lun_Mar_Mer_Jeu_Ven_Sam'.split('_'),
      yearLabel: 'YYYY',
    },
  },
  DatePicker: {
    placeholder: 'Veuillez choisir une date',
    datetimePlaceholder: "Veuillez sélectionner la date et l'heure",
    monthPlaceholder: 'Veuillez sélectionner un mois',
    yearPlaceholder: 'Veuillez choisir une année',
    now: 'Maintenant',
    selectTime: "Choisir l'heure",
    selectDate: 'Sélectionnez une date',
    ok: 'Confirmer',
    clear: 'Effacer',
    startPlaceholder: 'Date de début',
    endPlaceholder: 'Date de fin',
    hour: 'Heure',
    minute: 'minute',
    second: 'seconde',
  },
  Dialog: {
    close: 'Fermer',
    ok: 'Confirmer',
    cancel: 'Annuler',
  },
  Message: {
    closeAriaLabel: 'Fermer',
  },
  Pagination: {
    goTo: 'Aller vers',
    page: 'Page',
    total: 'Page {current}, sur {total}',
    labelPrev: 'Page précédente, page actuelle {current}',
    labelNext: 'Page suivante, page actuelle {current}',
    inputAriaLabel: 'Veuillez entrer le numéro de la page vers laquelle vous souhaitez accéder',
    selectAriaLabel: "Veuillez sélectionner le nombre d'entrées à afficher par page",
    pageSize: 'Élément(s)/Page',
  },
  Input: {
    clear: 'Effacer',
  },
  Select: {
    selectPlaceholder: 'Veuillez choisir',
    autoCompletePlaceholder: 'Veuillez saisir',
    notFoundContent: 'Aucune option',
    maxTagPlaceholder: '{selected}/{total} éléments sélectionnés',
  },
  Table: {
    empty: 'Aucune donnée',
    ok: 'Confirmer',
    reset: 'Réinitialiser',
    asc: 'Croissant',
    desc: 'Décroissant',
    expanded: 'Développé',
    folded: 'Réduit',
    filter: 'Filtrer',
    selectAll: 'Tout sélectionner',
  },
  TimePicker: {
    placeholder: 'Veuillez choisir une heure',
    startPlaceholder: 'Heure de début',
    endPlaceholder: 'Heure de fin',
    clear: 'Effacer',
    hour: 'heure',
    minute: 'min',
    second: 'seconde',
  },
  Transfer: {
    items: 'éléments',
    item: 'élément',
    moveAll: 'Déplacer tout',
    searchPlaceholder: 'Veuillez saisir',
    moveToLeft: "Désélectionner l'élément",
    moveToRight: 'Soumettre les éléments sélectionnés',
  },
  Upload: {
    card: {
      cancel: 'Annuler',
      addPhoto: "Télécharger l'image",
      download: 'Télécharger',
      delete: 'Supprimer',
    },
    drag: {
      text: 'Cliquez ou glissez le fichier dans la boîte pointillée pour télécharger',
      hint: 'Support des fichiers docx, xls, PDF, rar, zip, PNG, JPG, etc',
    },
    upload: {
      delete: 'Supprimer',
    },
  },
  Search: {
    buttonText: 'Rechercher',
  },
  Tag: {
    delete: 'Supprimer',
  },
  Rating: {
    description: "Options d'évaluation",
  },
};
